import { ReactComponent as IconFolder } from "@/assets/svgs/folder-outline.svg";
import { ReactComponent as IconMenu } from "@/assets/svgs/menu-light.svg";
import MenuDropDown from "@/components/MenuDropDown";
import useModal from "@/hooks/use-modal/index";
import { useLocation, useNavigate } from "@/lib/router-dom";
import React from "react";
import DeleteFolderModal from "./delete-folder-modal.jsx";
import PinToTop from "./pin-to-top.jsx";
import RenameFolderModal from "./rename-folder-modal.jsx";

export default function FolderCard({
	moveToFolder,
	item,
	// showDeleteFolderModal,
}) {
	const { goTo } = useNavigate();
	const [isDragOver, setIsDragOver] = React.useState(false);
	const { currentPath } = useLocation();
	const type = currentPath.includes("shared") ? "RECEIVE" : "SEND";
	const {
		visible: isShowRenameFolderModal,
		show: showRenameFolderModal,
		hide: hideRenameFolderModel,
	} = useModal();
	const {
		visible: isShowDeleteFolderModal,
		show: showDeleteFolderModal,
		hide: hideDeleteFolderModal,
	} = useModal();

	return (
		<>
			<div
				className={
					"eclip-landing_folder-card" +
					(isDragOver ? " drag-over" : "")
				}
				onClick={() => goTo(`/eclip/folder/${item.id}/${type}`)}
				onDrop={(ev) => {
					ev.preventDefault();
					const data = ev.dataTransfer.getData("text/plain");
					moveToFolder(data, { folderId: item?.id });
					setIsDragOver(false);
				}}
				onDragOver={(ev) => {
					ev.preventDefault();
					setIsDragOver(true);
				}}
				onDragLeave={(ev) => {
					ev.preventDefault();
					setIsDragOver(false);
				}}
			>
				<div className="eclip-landing__flex">
					<div className="eclip-landing-folder-box">
						<IconFolder />
					</div>
					<div className="eclip-landing_cursor-mode__pointer icon-group">
						<PinToTop eclipFolderId={item.id} pinned={item.pinned} />

						<MenuDropDown
							button={(props) => (
								<span
									className="eclip-landing_cursor-mode__pointer cursor-lg-area"
									{...props}
								>
									<IconMenu />
								</span>
							)}
							list={[
								{
									label: "Rename",
									onClick: (e) => {
										e.stopPropagation();
										showRenameFolderModal();
									},
								},
								{
									label: "Delete",
									onClick: (e) => {
										e.stopPropagation();
										showDeleteFolderModal();
									},
								},
							]}
						/>
					</div>
				</div>
				<div className="eclips-landing_folder--label eclip-landing_cursor-mode__pointer trim--three-lines">
					{item.name || "Untitled Folder"}
				</div>
			</div>
			<RenameFolderModal
				visible={isShowRenameFolderModal}
				close={hideRenameFolderModel}
				data={item}
			/>

			<DeleteFolderModal
				visible={isShowDeleteFolderModal}
				close={hideDeleteFolderModal}
				id={item?.id}
			/>
		</>
	);
}
